export function resolveAccountImportDom(page) {
    const card = page.querySelector('[data-account-import-card]');
    const confirmation = page.querySelector('[data-account-import-confirmation]');
    const confirmCheckbox = page.querySelector('[data-account-import-confirm-checkbox]');
    const executeTrigger = page.querySelector('[data-account-import-execute-trigger]');
    const form = page.querySelector('[data-account-import-form]');
    const input = page.querySelector('[data-account-import-input]');
    const trigger = page.querySelector('[data-account-import-trigger]');
    const feedback = page.querySelector('[data-account-import-feedback]');
    const selection = page.querySelector('[data-account-import-selection]');
    const executeUrl = String(page.dataset.accountImportExecuteUrl ?? '').trim();
    const validateUrl = String(page.dataset.accountImportValidateUrl ?? '').trim();

    if (!(card instanceof HTMLElement)
        || !(confirmation instanceof HTMLElement)
        || !(confirmCheckbox instanceof HTMLInputElement)
        || !(executeTrigger instanceof HTMLButtonElement)
        || !(form instanceof HTMLElement)
        || !(input instanceof HTMLInputElement)
        || !(trigger instanceof HTMLButtonElement)
        || !(feedback instanceof HTMLElement)
        || !(selection instanceof HTMLElement)
        || executeUrl === ''
        || validateUrl === '') {
        return null;
    }

    return {
        card,
        confirmCheckbox,
        confirmation,
        defaultTriggerLabel: trigger.textContent ?? 'Validate archive',
        defaultExecuteTriggerLabel: executeTrigger.textContent ?? 'Import archive',
        executeTrigger,
        executeUrl,
        feedback,
        form,
        input,
        selection,
        trigger,
        validateUrl,
    };
}
